/**
/**
 * @class LINEAuthRedirectCode
 */
export class LINEAuthRedirectCode {
    /** @access private @type {Array[LINEAuthRedirectCode]} */
    static _values = new Array()

    static MEMBERSCARD = new LINEAuthRedirectCode('memberscard', '会員証')
    static MY_PAGE_LINK = new LINEAuthRedirectCode('mypage-link', 'マイページ連携')

    /**
     * constructor LINEAuthRedirectCode
     * @constructor
     * @param {string} _code
     * @param {string} _description
     */
    constructor(_code, _description) {
        this.code = _code
        this.description = _description
        LINEAuthRedirectCode._values.push(this)
    }

    /**
     * find code
     * @param {string} provisionShopCode
     * @returns {Sex|undefined}
     */
    static findByCode(_code) {
        return LINEAuthRedirectCode._values.find((site) => site.code === _code)
    }
}
